window['dataLayer'] = window['dataLayer'] || [];

export const track = (event: string, contents: object) => {
  const entry = { ...contents, event };
  window['dataLayer']?.push(entry);
};
